import React, { useEffect, useState } from "react";
import { Alert, Button, Flex, Text } from "@fluentui/react-northstar";

import { DocumentCopy20Regular } from "@fluentui/react-icons";
import { LinkText } from "./style";
import useCopyToClipboard from "../../../../hooks/useCopyToClipboard";
import styled, { keyframes } from "styled-components";

const ALERT_ANIMATION_DURATION_MS = 500;

const CopyText = ({
    content,
    width = "300px",
    noBorder = false,
    noAlert = false,
    isEmail = true,
}) => {
    const [copied, setCopyToClipBoard] = useCopyToClipboard(content);
    const [alertVisible, setAlertVisible] = useState(false);

    const copiedOnClick = () => {
        setCopyToClipBoard();
    };

    useEffect(() => {
        if (copied) {
            setAlertVisible(true);
        } else if (alertVisible) {
            const timeout = setTimeout(
                () => setAlertVisible(false),
                ALERT_ANIMATION_DURATION_MS
            );
            return () => clearTimeout(timeout);
        }
    }, [copied]);

    return (
        <Flex
            vAlign="center"
            space="between"
            styles={{ width, overflow: "hidden" }}
        >
            {alertVisible && !noAlert && (
                <AlertCopied
                    content={"Élément copié !"}
                    className={copied ? "fade-in-right" : "fade-out-right"}
                />
            )}
            {content ? (
                <LinkText href={isEmail ? `mailto:${content}` : "#"}>
                    {content}
                </LinkText>
            ) : (
                <Text content="-" />
            )}
            {content && (
                <Button
                    onClick={copiedOnClick}
                    iconOnly
                    icon={<DocumentCopy20Regular />}
                    flat
                    text={noBorder}
                />
            )}
        </Flex>
    );
};

export default CopyText;

const fadeInRight = keyframes`
    0% {
        opacity: 0;
        right : 0px;
    }
    100% {
        opacity: 1;
        right: 45%;
    }
`;

const fadeOutRight = keyframes`
    0% {
        opacity: 1;
        right: 45%;
    }
    100% {
        opacity: 0;
        right: 0px;
    }
`;

const AlertCopied = styled(Alert)`
    position: absolute;
    top: 50%;
    z-index: 9999;
    background-color: black;
    color: white;
    font-weight: 600;
    height: 36px;

    opacity: 0;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;

    &.fade-in-right {
        animation-name: ${fadeInRight};
    }

    &.fade-out-right {
        animation-name: ${fadeOutRight};
    }
`;
